/* eslint-disable compat/compat */
class KlaviyoSignupForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'email', 'successState']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(
      this.els.form.element,
      'submit',
      this.formSubmissionHandler.bind(this),
    )
  }

  showNewsletterSuccess () {
    this.querySelector('.frm-Form_Row').style.display = 'none'
    this.querySelector('.kla-Form_SuccessState').ariaHidden = 'false'
  }

  formSubmissionHandler (event) {
    event.preventDefault()

    const email = this.els.email.element.value

    if (email === '') return

    this.postData(email).then((response) => {
      if (response && response.ok) {
        this.showNewsletterSuccess()
      }
    }).catch((error) => {
      console.error('An error occurred during the fetch operation:', error)
    })
  }

  async postData (email) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: {
                  shade_finder_quiz_product: `${this.els.result.element.dataset.klaviyoShadeFinderProductResult}`,
                  shade_finder_quiz_variant: `${this.els.result.element.dataset.klaviyoShadeFinderVariantResult}`,
                  shade_finder_quiz_product_url: `${this.els.result.element.dataset.klaviyoShadeFinderProductUrlResult}`,
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: `${this.els.formId.element.dataset.klaviyoSignupFormList}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      return response
    } catch (error) {
      throw new Error('Fetch failed:', error)
    }
  }
}

if (!customElements.get('klaviyo-signup-form')) {
  customElements.define('klaviyo-signup-form', KlaviyoSignupForm)
}
